/**
 * @file index.tsx
 * @module app/modules/member-dashboard/index
 * @description Implements the index interface for the member dashboard.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Outlet, Route, Routes } from "react-router-dom";
import { DashboardWrapper } from "./dashboard";
const DashboardIndex = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route index element={<DashboardWrapper />} />
    </Route>
  </Routes>
);
export default DashboardIndex;
